import { Component, Inject, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { ClipboardModule } from '@angular/cdk/clipboard';
import { IconComponent } from '../../helper/icon/icon.component';
import { AccountService } from '../../service/account.service';

@Component({
  selector: 'app-connect-vrchat-fail',
  imports: [MatDialogModule, MatButtonModule, MatCardModule, MatIconModule, MatFormFieldModule, MatInputModule, ClipboardModule, IconComponent],
  templateUrl: './connect-vrchat-fail.component.html',
  styleUrl: './connect-vrchat-fail.component.less'
})
export class ConnectVrchatFailComponent {
  retrying = false;
  accountService = inject(AccountService);

  constructor(
    public dialogRef: MatDialogRef<ConnectVrchatFailComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { message: string, discord_url?: string, recovery_token?: string, username: string }
  ) {}

  openDiscord() {
    if (this.data.discord_url) {
      window.open(this.data.discord_url, '_blank');
    }
  }

  retryConnection() {
    this.retrying = true;
    this.accountService.connectVRChat(this.data.username).subscribe({
      next: (res: any) => {
        this.retrying = false;
        if (res.code == 200) {
          this.dialogRef.close({ success: true });
        } else {
          this.data.message = res.message;
          if (res.recovery_token) {
            this.data.recovery_token = res.recovery_token;
          }
          if (res.discord_url) {
            this.data.discord_url = res.discord_url;
          }
        }
      },
      error: (error: any) => {
        console.error('Failed to retry VRChat connection:', error);
        this.retrying = false;
      }
    });
  }

  copyToken() {
    if (this.data.recovery_token) {
      navigator.clipboard.writeText(this.data.recovery_token);
    }
  }
}
